<template>
  <p>
    Return to the
    <a class="app-link-open" href="http://www.dmv.ri.gov/" target="_blank"
       rel="noopener noreferrer">RI DMV home page<span class="sr-only">(opens in a new window or tab)</span></a>
  </p>
</template>

<script setup>
defineOptions({
  name: 'RiDmvHome',
});
</script>
